import { User } from '@/client/services/api/graphql/gql/graphql';
import { bulkUserSearchFromEmailsQuery } from '../../api/queries/bulkUserSearchFromEmailsQuery';
import { graphQLClient } from '@/client/services/api/clients/graphqlClient';
import { useMutation } from '@tanstack/react-query';

export const useBulkUserSearchFromEmails = () => {
  const bulkUserSearchFromEmailsMutation = useMutation({
    mutationFn: async (emails: string[]): Promise<User[]> => {
      const data: any = await graphQLClient.request(bulkUserSearchFromEmailsQuery, {
        userEmails: emails,
      });

      return data.bulkUserSearch.users;
    },
  });

  return { bulkUserSearchFromEmailsMutation };
};
